var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyringe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.342,
    height: 22.342,
    viewBox: "0 0 22.342 22.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27383",
    "data-name": "Caminho 27383",
    d: "M133.171,62.375,130.395,59.6a2.823,2.823,0,0,0-.347-3.572L119.785,45.766,122,43.554a.545.545,0,1,0-.77-.771l-3.353,3.352L115.136,43.4l1.5-1.5a.545.545,0,1,0-.771-.771l-4.72,4.72a.545.545,0,1,0,.771.771l1.5-1.5,2.739,2.739L112.808,51.2a.545.545,0,0,0,.771.77l2.212-2.213,1.311,1.312,1.137-1.137a.273.273,0,0,1,.386.386l-1.137,1.137,1.447,1.446,1.137-1.137a.273.273,0,0,1,.386.386l-1.137,1.137,1.446,1.447L121.9,53.6a.273.273,0,0,1,.386.386l-1.137,1.137,1.447,1.447,1.137-1.137a.273.273,0,0,1,.386.386l-1.137,1.138,1.447,1.446,1.137-1.136a.273.273,0,0,1,.386.386l-1.137,1.136,1.235,1.236a2.823,2.823,0,0,0,3.572.347l2.777,2.777a.544.544,0,1,0,.77-.77Z",
    transform: "translate(-110.989 -40.963)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringe);
export default __webpack_public_path__ + "static/media/syringe.e3c77051f0718b8e49ede972827a5cfb.svg";
export { ForwardRef as ReactComponent };